require('./_wks-define')('observable');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/es7.symbol.observable.js
 ** module id = 500
 ** module chunks = 0 1
 **/